import React, { useState } from 'react';

interface SearchFiltersProps {
  categories: string[];
  types: string[];
  dates: string[];
  authors: string[];
  onApply: (filters: {
    category: string;
    type: string;
    date: string;
    author: string;
  }) => void;
}

export const SearchFilters: React.FC<SearchFiltersProps> = ({ categories, types, dates, authors, onApply }) => {
  const [category, setCategory] = useState('Todas as categorias');
  const [type, setType] = useState('Todos os tipos');
  const [date, setDate] = useState('Qualquer data');
  const [author, setAuthor] = useState('Todos os autores');

  const handleApply = (e: React.FormEvent) => {
    e.preventDefault();
    onApply({ category, type, date, author });
  };

  return (
    <form className="bg-white rounded-lg shadow p-6 mb-6 flex flex-wrap gap-4 items-end" onSubmit={handleApply}>
      <div className="flex flex-col flex-1 min-w-[180px]">
        <label className="mb-1 font-medium text-gray-700">Categoria</label>
        <select className="rounded-md border px-3 py-2" value={category} onChange={e => setCategory(e.target.value)}>
          <option>Todas as categorias</option>
          {categories.map((cat, idx) => (
            <option key={idx}>{cat}</option>
          ))}
        </select>
      </div>
      <div className="flex flex-col flex-1 min-w-[180px]">
        <label className="mb-1 font-medium text-gray-700">Tipo de Documento</label>
        <select className="rounded-md border px-3 py-2" value={type} onChange={e => setType(e.target.value)}>
          <option>Todos os tipos</option>
          {types.map((t, idx) => (
            <option key={idx}>{t}</option>
          ))}
        </select>
      </div>
      <div className="flex flex-col flex-1 min-w-[180px]">
        <label className="mb-1 font-medium text-gray-700">Data</label>
        <select className="rounded-md border px-3 py-2" value={date} onChange={e => setDate(e.target.value)}>
          <option>Qualquer data</option>
          {dates.map((d, idx) => (
            <option key={idx}>{d}</option>
          ))}
        </select>
      </div>
      <div className="flex flex-col flex-1 min-w-[180px]">
        <label className="mb-1 font-medium text-gray-700">Autor</label>
        <select className="rounded-md border px-3 py-2" value={author} onChange={e => setAuthor(e.target.value)}>
          <option>Todos os autores</option>
          {authors.map((a, idx) => (
            <option key={idx}>{a}</option>
          ))}
        </select>
      </div>
      <button type="submit" className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md font-medium ml-auto">
        Aplicar Filtros
      </button>
    </form>
  );
}; 